import LoginView from "components/layout/login-view";
import { useEffect } from "react";
import { logout } from "stores/actions/auth";

const UserFinishedView = () => {
  useEffect(() => {
    logout();
  }, []);

  return (
    <LoginView title="Kiitos ilmoituksesta" transition={false}>
      Sinut on kirjattu ulos ja voit nyt sulkea selaimen.
      <br />
      <br />
      Voidaksesi kirjautua uudestaan, sinun tulee avata sähköpostiisi saapunut
      kirjautumislinkki.
      <br />
      <br />
      Ongelmatilanteissa ota yhteyttä organisaatiosi ylläpitäjään.
    </LoginView>
  );
};

export default UserFinishedView;
